import {
    GET_APPROVAL_HISTORY_LIST,
    SET_APPROVAL_HISTORY_LIST
} from "./ApprovalHistoryType"


const getApprovalHistoryList = (orderRequestId: number) => ({
    type: GET_APPROVAL_HISTORY_LIST,
    orderRequestId
});

const setApprovalHistoryList = (approvalHistory: any) => ({
    type: SET_APPROVAL_HISTORY_LIST,
    approvalHistory
});

export {
    getApprovalHistoryList,
    setApprovalHistoryList
}